/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlEntityLookalikesDnsAnswer
 */
export interface ControlEntityLookalikesDnsAnswer {
    /**
     * 
     * @type {string}
     * @memberof ControlEntityLookalikesDnsAnswer
     */
    answer?: string;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityLookalikesDnsAnswer
     */
    preference?: number;
}

/**
 * Check if a given object implements the ControlEntityLookalikesDnsAnswer interface.
 */
export function instanceOfControlEntityLookalikesDnsAnswer(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlEntityLookalikesDnsAnswerFromJSON(json: any): ControlEntityLookalikesDnsAnswer {
    return ControlEntityLookalikesDnsAnswerFromJSONTyped(json, false);
}

export function ControlEntityLookalikesDnsAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityLookalikesDnsAnswer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'answer': !exists(json, 'answer') ? undefined : json['answer'],
        'preference': !exists(json, 'preference') ? undefined : json['preference'],
    };
}

export function ControlEntityLookalikesDnsAnswerToJSON(value?: ControlEntityLookalikesDnsAnswer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'answer': value.answer,
        'preference': value.preference,
    };
}

